module.exports = __webpack_public_path__ + "static/media/5-4.1f4b60a0.mp3";